module.exports = __webpack_public_path__ + "static/img/发票管理3.b48ca8d9.png";